import React, { useState } from 'react';

import { PropertyAreaText, PropertyPriceText } from '$partials/properties';
import IconArrow from '$partials/icons/icon-arrow';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

const LIST_CUTOFF = 4;

/**
 * @type {import('$types/components/partials/new-home').NewHomePropertyList}
 */

const NewHomePropertyList = (props) => {
    const [showAll, setShowAll] = useState(false);

    return (
        <div className='module-highlights-amenities-block'>
            <div className='module-product-detail-section bg-main-blackground'>
                <div className='layout-container layout-site-outer-padding py-16 sm:py-40 md:py-48'>
                    <div className='flex gap-y-32 flex-col md:flex-row col-wrapper'>
                        <div className='md:w-4/12 col-padding'>
                            <h2 className='type-style-2'>{'Available properties'}</h2>
                        </div>

                        <div
                            aria-label='Properties list'
                            className='pt-10 flex flex-col col-padding md:w-8/12'
                            role='table'>
                            {/* Table header */}
                            <div
                                className={'w-full pb-16'}
                                role='rowgroup'>
                                <div
                                    className='w-full flex type-style-eyebrow'
                                    role='row'>
                                    <div
                                        className='w-3/8'
                                        role='columnheader'>
                                        {'Property'}
                                    </div>
                                    <div
                                        className='w-1/8'
                                        role='columnheader'>
                                        {'Beds'}
                                    </div>
                                    <div
                                        className='w-1/8'
                                        role='columnheader'>
                                        {'Bath'}
                                    </div>
                                    <div
                                        className='w-1/8'
                                        role='columnheader'>
                                        {'Int. size'}
                                    </div>
                                    <div
                                        className='w-2/8'
                                        role='columnheader'>
                                        {'Price'}
                                    </div>
                                </div>
                            </div>

                            {/* Divider */}
                            <div
                                aria-hidden={true}
                                className='w-full h-[1px] bg-main-border'>
                            </div>

                            <div
                                className={'w-full flex flex-col divide-y divide-main-border'}
                                role='rowgroup'>
                                {props.properties?.edges?.length > 0 && (
                                    <>
                                        {props.properties.edges.map((edge, i) => {
                                            if (!showAll && i > LIST_CUTOFF) {
                                                return null;
                                            }

                                            return (
                                                <div
                                                    className='w-full flex flex-wrap type-style-eyebrow sm:type-style-body-r expand-interaction py-16'
                                                    key={edge.node.id}
                                                    role='row'>
                                                    {/* Property */}
                                                    <div
                                                        className='w-full pb-8 sm:pb-0 sm:w-3/8'
                                                        role='cell'>
                                                        <a
                                                            className='expand-interaction__action type-style-body-r'
                                                            href={edge.node.url}>
                                                            {edge.node.newHomeUnitDisplayName}
                                                        </a>
                                                    </div>
                                                    {/* Beds */}
                                                    <div
                                                        className='w-2/12 sm:w-1/8'
                                                        role='cell'>
                                                        {edge.node.bedrooms} bed
                                                    </div>
                                                    {/* Bath */}
                                                    <div
                                                        className='w-2/12 sm:w-1/8'
                                                        role='cell'>
                                                        {edge.node.bathrooms} bath
                                                    </div>
                                                    {/* Int. size */}
                                                    <div
                                                        className='w-2/12 sm:w-1/8'
                                                        role='cell'>
                                                        <PropertyAreaText
                                                            areaMeters={edge.node.livingAreaMeters}
                                                            isOffMarket={edge.node.isOffMarket} />
                                                    </div>
                                                    {/* Price */}
                                                    {edge.node.price &&
                                                        <div
                                                            className='w-6/12 sm:w-2/8'
                                                            role='cell'>
                                                            <PropertyPriceText
                                                                isOffMarket={edge.node.isOffMarket}
                                                                pageType={edge.node.__typename}
                                                                price={edge.node.price}
                                                                priceCurrency={edge.node.priceCurrency}
                                                                priceRentPeriod={edge.node.priceRentPeriod} />
                                                        </div>
                                                    }
                                                </div>
                                            );
                                        })}

                                        {(!showAll && props.properties.edges.length - (LIST_CUTOFF + 1) > 0) && (
                                            <button
                                                aria-label='Show all properties in list'
                                                className='type-style-eyebrow inline-flex gap-8 items-center py-16'
                                                onClick={() => setShowAll(true)}
                                                type='button'>
                                                {`${props.properties.edges.length - (LIST_CUTOFF + 1)} more`}
                                                <span aria-hidden={true}>
                                                    <IconArrow className='rotate-90 h-10' />
                                                </span>
                                            </button>
                                        )}
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default NewHomePropertyList;
